import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredVideos = videos.filter((v) => {
    if (slug === 'japan-sakura') return v.category === '日本樱花';
    if (slug === 'china-sakura') return v.category === '中国樱花';
    if (slug === 'timelapse') return v.category === '延时摄影';
    if (slug === 'travel-vlog') return v.category === '旅行Vlog';
    if (slug === 'viewing-guide') return v.category === '赏樱攻略';
    return false;
  });

  const [activeCat, setActiveCat] = useState(slug || '');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [slug]);

  useEffect(() => {
    setActiveCat(slug || '');
  }, [slug]);

  useEffect(() => {
    if (category) {
      document.title = `${category.name} - 樱花视频 | 高清${category.name}在线观看`;
    } else {
      document.title = '视频分类 - 樱花视频';
    }
  }, [category]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-16 flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200/70">
              <i className="ri-error-warning-line text-2xl text-foreground-400"></i>
            </div>
            <p className="mt-4 text-foreground-600">分类不存在</p>
            <Link to="/" className="mt-4 inline-block text-sm text-primary-600 hover:text-primary-700">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
        <ScrollToTop />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: category.name },
            ]}
          />

          <div className="mt-6 mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {category.name}
            </h1>
            <p className="mt-2 text-sm text-foreground-600">
              {category.description} · 共 {filteredVideos.length} 个视频
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                  activeCat === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredVideos.map((video) => (
              <VideoCard key={video.id} {...video} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}